import { dataFrowningFace } from 'dls-icons-data'
import { createIcon } from '../common'

const IconFrowningFace = /*#__PURE__*/createIcon(dataFrowningFace)
export default IconFrowningFace
